import styled from 'styled-components';
import CustomTag from '@components/CustomTag';

export const GroupTag = styled(CustomTag)`
  margin: 4px;
  padding: 8px;
  font-size: 0.9rem;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;

  .anticon-edit svg {
    fill: ${({ theme }) => theme.colors.blue};
  }

  .anticon-delete svg {
    fill: ${({ theme }) => theme.colors.red};
  }
`;
